/* Magic kits page (sections/magic-kits.liquid): the "What do you want to do first?"
   picker and Add to bag through the theme cart (window.TOMSCart.addItems, as the
   gift guide does). Without JavaScript the first kit shows and the forms post. */
(function () {
  var root = document.querySelector('[data-kp]');
  if (!root) return;
  var words = {};
  try { words = JSON.parse((root.querySelector('[data-kp-words]') || {}).textContent || '{}'); } catch (e) {}

  /* picker */
  var chips = root.querySelectorAll('[data-kp-chip]');
  var cards = root.querySelectorAll('[data-kp-match]');
  Array.prototype.forEach.call(chips, function (chip) {
    chip.addEventListener('click', function () {
      var id = chip.getAttribute('data-kp-chip');
      Array.prototype.forEach.call(chips, function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      Array.prototype.forEach.call(cards, function (card) {
        var on = card.getAttribute('data-kp-match') === id;
        card.hidden = !on;
        if (on) {
          var why = card.querySelector('[data-kp-why]');
          if (why && chip.getAttribute('data-why')) why.textContent = chip.getAttribute('data-why');
        }
      });
    });
  });

  /* add to bag */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kp-form]');
    if (!form || !window.TOMSCart || !window.TOMSCart.addItems) return; /* no theme cart: post the form */
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var id = form.querySelector('[name="id"]');
    if (!id || (btn && btn.disabled)) return;
    var label = btn ? btn.innerHTML : '';
    window.TOMSCart.addItems([{ id: Number(id.value), quantity: 1 }], btn).then(function (cart) {
      if (!cart || !btn) return;
      btn.textContent = '✓ ' + (words.added || 'Added');
      btn.classList.add('kp-done');
      setTimeout(function () { btn.innerHTML = label; btn.classList.remove('kp-done'); }, 2200);
    });
  });
})();
